import { createContext, useContext, useEffect, useMemo } from 'react'
import { useStopwatch } from 'react-timer-hook'

const defaultCallDuration = {
  seconds: 0,
  minutes: 0,
  hours: 0,
  days: 0,
}

type CallDurationParams = typeof defaultCallDuration

const CallDurationContext =
  createContext<CallDurationParams>(defaultCallDuration)

export const useCallDuration = () => useContext(CallDurationContext)

const CallDurationProvider = ({ children, status }) => {
  const { seconds, minutes, hours, days, start, reset } = useStopwatch({
    autoStart: false,
  })

  useEffect(() => {
    if (status === 'Ringing...') {
      reset(undefined, false)
    } else if (status === 'Recording...') {
      start()
    } else if (status === 'Dial') {
      stop()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status])

  const value = useMemo(
    () => ({
      seconds,
      minutes,
      hours,
      days,
    }),
    [seconds, minutes, hours, days],
  )

  return (
    <CallDurationContext.Provider value={value}>
      {children}
    </CallDurationContext.Provider>
  )
}

export default CallDurationProvider
